export default "__VITE_ASSET__Bqs63BZf__"